var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbumEditOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.album-edit{fill:#dcdcdc;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "album-edit",
    d: "m410 940-16-115q-20-6-46.309-20.227Q321.382 790.545 304 774l-106 47-70-127 91-69.165q-1-10.761-2.5-24.135-1.5-13.374-1.5-25.7 0-10.457 1.5-23.025Q218 539.407 219 524l-91-69 70-123 103 45q20-16 45-30.5t47-21.5l17-114h141l15 115q25 9 47 22t42 29l109-45 69 123-97 72q3 14 4.5 26.5T742 576q0 9-2 21.5t-3 27.5l94 69-70 127-108-48q-21 18-43 31.5T567 824l-16 116H410Zm66-266q41.8 0 70.4-28.559 28.6-28.558 28.6-70.3 0-41.741-28.6-70.441Q517.8 476 476 476q-41 0-70 28.559-29 28.558-29 70.3 0 41.741 29 70.441 29 28.7 70 28.7Zm-.618-35Q449 639 430.5 620.174 412 601.348 412 574.882q0-26.465 18.706-45.174 18.706-18.708 45-18.708Q503 511 521.5 529.826q18.5 18.826 18.5 45.292 0 26.465-18.618 45.174-18.617 18.708-46 18.708ZM480 575Zm-41 330h81.212l15.038-112q30.75-8 55.663-22.085Q615.827 756.83 644.182 731L745 775l40-69-89-67q4-18.636 6.5-33.964t2.5-30.182q0-16.854-2.5-30.354T697 513l90-68-39-69-105 43q-18-20-50.073-39.795Q560.853 359.41 533.598 356L522 246h-84l-11 109q-34 7-60.5 22T314 418l-100.717-42L172 445l89 66q-5 15-7 31t-2 33.485q0 15.515 2 31.015t6 32.5l-88 67 41 69 101-43q26 27 52.5 41t59.5 22l13 110Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumEditOff);
export default __webpack_public_path__ + "static/media/album_edit_off.d1a9dc2143e9ee078b961324a152ddf7.svg";
export { ForwardRef as ReactComponent };